import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import TopNav from './TopNav.jsx'
import UsageBanner from './UsageBanner.jsx'
import { useAuth } from '../../contexts/AuthContext.jsx'

export default function AppShellLayout() {
  const loc = useLocation()
  const { token, usage, refreshUsage } = useAuth()
  const hideNav = loc.pathname.startsWith('/sessions/live/')

  useEffect(() => {
    if (token && !usage) refreshUsage()
  }, [token, usage, refreshUsage])

  return (
    <div className="min-h-full bg-bg">
      {!hideNav && <TopNav />}
      {!hideNav && <UsageBanner usage={usage} />}
      <Outlet />
    </div>
  )
}
